const PROMOTION_TYPE = {
  TIME_SALE: {
    color: 'blue',
    label: '타임세일',
    value: 'TIME_SALE',
  },
  PROMOTION: {
    color: 'purple',
    label: '프로모션',
    value: 'PROMOTION',
  },
};

const PROMOTION_YES_OR_NO = {
  Y: {
    SENT: { text: '성공', value: 'Y' },
    SHOW: { text: '노출', value: 'Y' },
    ENABLE: { text: '활성화', value: 'Y' },
  },
  N: {
    SENT: { text: '실패', value: 'N' },
    SHOW: { text: '숨김', value: 'N' },
    ENABLE: { text: '비활성화', value: 'Y' },
  },
};
export { PROMOTION_TYPE, PROMOTION_YES_OR_NO };
